import {
  VOLUNTARY_ORDER_TYPES as voluntaryOrderTypesInsightt,
  INVOLUNTARY_ORDER_TYPES as involuntaryOrderTypesInsightt,
  IMPOUND_ORDER_TYPES as impoundOrderTypesInsightt,
  PEOPLE_WORKING_ALL_ROLES,
  PEOPLE_WORKING_OTHER_ROLES,
  UserStatus,
  UserType,
  CaseStatus,
} from '@rapid-recovery-agency-inc/insightt-shared';
import { DateTime } from 'luxon';
import { Library } from '@googlemaps/js-api-loader';
import { DAILY_MAP_TOGGLE_OPTIONS } from '../shared/components/maps/constants';
import { DateConstants } from '../views/app/shift/for-user/my-stats/my-stats.data';
import {
  CameraHitsStatus,
  CasesUnitReachStatus,
  HitType,
  OrderType,
  SpotType as SpottersTabs,
} from '@rapid-recovery-agency-inc/insightt-graphql';

export const googleMapsConfig: {
  libraries: Library[];
  id: string;
} = {
  libraries: ['places'],
  id: 'load-api-script',
};

/*
  This delay is necessary so that the returned
  method can be executed to cancel the request
  and a new request with a new signal can be
  executed later.
*/

export const FullScreenRoutes = ['/create-shift', '/create-checklist', '/edit-shift'];

export const TIME_DELAY_FOR_FETCH_AFTER_ABORT = 20;

export const TOKEN_EXPIRED = 'Your token has been expired. Please login again';

export const RDN_TIMEZONE_OFFSET = 7;

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const ANSWER_OPTIONS = [
  { value: 1, label: 'YES' },
  { value: 0, label: 'NO' },
];

export const ARROW_TYPES = {
  up: 'UP',
  down: 'DOWN',
};

export const DEVICE_TYPES = {
  web: 'web',
  mobile: 'mobile',
};

export const CASE_STATUSES = {
  open: 'Open',
  need_info: 'Need Info',
  pending_close: 'Pending Close',
  pending_on_hold: 'Pending On Hold',
  closed: 'Closed',
  onHold: 'On Hold',
  repossessed: 'Repossessed',
};

export const CASE_ORDER_TYPES = {
  condReport: 'Cond. Report',
  investigate: 'Investigate',
  investigateRepo: 'Investigate/Repo',
  pictures: 'Pictures',
  voluntary: 'Vol. Repo',
  lprStaging: 'LPR Staging',
  involuntary: 'Repossess',
  impoundRepo: 'Impound Repo',
  impoundVoluntary: 'Impound Voluntary',
  fieldVisit: 'Field Visit',
};

export const ADDRESS_OPTION_OTHER = 'OTHER';

export const VOLUNTARY_ORDER_TYPES = voluntaryOrderTypesInsightt;

export const INVOLUNTARY_ORDER_TYPES = involuntaryOrderTypesInsightt;

export const IMPOUND_ORDER_TYPES = impoundOrderTypesInsightt;

export const INFRACTION_TYPES = {
  shift_start_later: 'shift_start_later',
  shift_end_early: 'shift_end_early',
  shift_inactivity: 'shift_inactivity',
  shift_being_idle: 'shift_being_idle',
  shift_break_over_time: 'shift_break_over_time',
  task_not_completed_in_time: 'task_not_completed_in_time',
};

export const ALERT_METHODS = {
  sms: 'sms',
  email: 'email',
};

/* User Roles & Types */
/**
 *  @deprecated - use UserRoles.SYSTEM_ADMIN_ROLE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const SYSTEM_ADMIN = 'system_admin';
/**
 * @deprecated - use UserRoles.SUPER_ADMIN_ROLE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const SUPER_ADMIN_ROLE = 'super_admin';
/**
 * @deprecated - use UserRoles.ADMIN_ROLE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const ADMIN_ROLE = 'admin';
/**
 * @deprecated - use UserRoles.MANAGER_ROLE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const MANAGER_ROLE = 'manager';
/**
 * @deprecated - use UserRoles.DRIVER_ROLE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const DRIVER_ROLE = 'driver';

/**
 * @deprecated - use ADMIN_ROLES from @rapid-recovery-agency-inc/insightt-shared
 */
export const ADMIN_ROLES = [SUPER_ADMIN_ROLE, ADMIN_ROLE];
/**
 * @deprecated - use MANAGER_ROLES from @rapid-recovery-agency-inc/insightt-shared
 */
export const MANAGER_ROLES = [SUPER_ADMIN_ROLE, ADMIN_ROLE, MANAGER_ROLE];

/**
 *  @deprecated - use UserTypes.SUPER_ADMIN_TYPE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const SUPER_ADMIN = 'super_admin';
/**
 *  @deprecated - use UserTypes.ADMINISTRATOR_TYPE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const ADMINISTRATOR = 'administrator';
/**
 *  @deprecated - use UserTypes.CUSTOMER_REP_TYPE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const ADMIN_REP = 'customer_rep';

/**
 *  @deprecated - use UserTypes.BRANCH_MANAGER_TYPE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const BRANCH_MANAGER = 'branch_manager';
/**
 *  @deprecated - use UserTypes.INVESTIGATOR_TYPE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const INVESTIGATOR = 'investigator';
/**
 *  @deprecated - use UserTypes.RECOVERY_AGENT_TYPE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const RECOVERY_AGENT = 'recovery_agent';
/**
 *  @deprecated - use UserTypes.SPOTTER_TYPE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const SPOTTER = 'spotter';
/**
 *  @deprecated - use UserTypes.CAMERA_CAR_TYPE instead (@rapid-recovery-agency-inc/insightt-shared)
 */
export const CAMERA_CAR = 'camera_car';

/* Ranking users cards names */
export const TOP_RECOVERY_AGENTS_CARD_NAME = 'Top Recovery Agents';
export const TOP_SPOTTERS_CARD_NAME = 'Top Spotters';
export const TOP_CAMERA_CARS_CARD_NAME = 'Top Camera Cars';

/* OverView */
export const RECOVERY_AGENTS_RANK_OPTIONS = [
  {
    value: 1,
    label: 'Total Repossessions',
    trackingEvent: 'TRA_CARD: CLICKED_TOTAL_REPOS',
    card: TOP_RECOVERY_AGENTS_CARD_NAME,
  },
  {
    value: 2,
    label: 'Involuntary',
    trackingEvent: 'TRA_CARD: CLICKED_INVOLUNTARY',
    card: TOP_RECOVERY_AGENTS_CARD_NAME,
  },
  {
    value: 3,
    label: 'Voluntary',
    trackingEvent: 'TRA_CARD: CLICKED_VOLUNTARY',
    card: TOP_RECOVERY_AGENTS_CARD_NAME,
  },
];

export enum RecoveryTabs {
  TOTAL_REPOSSESSIONS,
  INVOLUNTARY,
  VOLUNTARY,
  IMPOUND,
}

export enum CameraCarsTabs {
  TOTAL_SCANS,
  LIVE_HITS,
  SECURED,
}

export const RECOVERY_AGENTS_RANK_OPTIONS_V2 = [
  {
    value: RecoveryTabs.TOTAL_REPOSSESSIONS,
    label: 'Total Repossessions',
    queryValue: null,
    trackingEvent: 'TRA_CARD: CLICKED_TOTAL_REPOS',
    card: TOP_RECOVERY_AGENTS_CARD_NAME,
  },
  {
    value: RecoveryTabs.INVOLUNTARY,
    label: 'Involuntary',
    queryValue: OrderType.INVOLUNTARY,
    trackingEvent: 'TRA_CARD: CLICKED_INVOLUNTARY',
    card: TOP_RECOVERY_AGENTS_CARD_NAME,
  },
  {
    value: RecoveryTabs.VOLUNTARY,
    label: 'Voluntary',
    queryValue: OrderType.VOLUNTARY,
    trackingEvent: 'TRA_CARD: CLICKED_VOLUNTARY',
    card: TOP_RECOVERY_AGENTS_CARD_NAME,
  },
  {
    value: RecoveryTabs.IMPOUND,
    label: 'Impound',
    queryValue: OrderType.IMPOUND,
    trackingEvent: 'TRA_CARD: CLICKED_IMPOUND',
    card: TOP_RECOVERY_AGENTS_CARD_NAME,
  },
];

export const RECOVERY_AGENTS_RANK_OPTIONS_FOR_FETCH = [
  { value: 1, label: 'Total Repossessions' },
  { value: 2, label: 'Involuntary' },
  { value: 3, label: 'Voluntary' },
  { value: 4, label: 'Impound' },
];

export const SPOTTERS_RANK_OPTIONS = [
  {
    value: 1,
    label: 'Total Spotted',
    trackingEvent: 'TS_CARD: CLICKED_TOTAL_SPOTTED',
    card: TOP_SPOTTERS_CARD_NAME,
  },
  {
    value: 2,
    label: 'Secured',
    trackingEvent: 'TS_CARD: CLICKED_SECURED',
    card: TOP_SPOTTERS_CARD_NAME,
  },
  {
    value: 3,
    label: 'Closed',
    trackingEvent: 'TS_CARD: CLICKED_CLOSED',
    card: TOP_SPOTTERS_CARD_NAME,
  },
];

export const SPOTTERS_RANK_OPTIONS_FOR_FETCH = [
  { value: 1, label: 'Total Spotted' },
  { value: 2, label: 'Secured' },
  { value: 3, label: 'Closed' },
  { value: 4, label: 'Need Info' },
];

export const CAMERA_CARS_RANK_OPTIONS_V2 = [
  {
    value: CameraCarsTabs.TOTAL_SCANS,
    label: 'Total Unique Scans',
    trackingEvent: 'TCC_CARD: CLICKED_TOTAL_SCANS',
    card: TOP_CAMERA_CARS_CARD_NAME,
  },
  {
    value: CameraCarsTabs.LIVE_HITS,
    label: 'Live Hits',
    trackingEvent: 'TCC_CARD: CLICKED_LIVE_HITS',
    card: TOP_CAMERA_CARS_CARD_NAME,
  },
  {
    value: CameraCarsTabs.SECURED,
    label: 'Secured',
    trackingEvent: 'TCC_CARD: CLICKED_SECURED',
    card: TOP_CAMERA_CARS_CARD_NAME,
  },
];

/* Human Resources */
export const USER_STATUSES = [
  { value: 1, label: UserStatus.ACTIVE },
  { value: 2, label: UserStatus.DISABLED },
];

/* Manage Checklist */
export const CHECKLIST_TYPES = {
  new_hire: 'new_hire',
  terminate: 'terminate',
  start_shift: 'start_shift',
  end_shift: 'end_shift',
  activity_tracker: 'activity_tracker',
  motion_tracker: 'motion_tracker',
};

export const CHECKLIST_STATUSES = {
  yes: 'Yes',
  no: 'No',
};

export const CHECKLIST_TYPES_LABELS = {
  new_hire: 'New Hire',
  terminate: 'Terminate',
  start_shift: 'Start Shift',
  end_shift: 'End Shift',
  activity_tracker: 'Activity Tracker',
  motion_tracker: 'Motion Tracker',
};

export const ROLE_OPTIONS = [
  { value: 2, label: 'Branch Manager' },
  { value: 3, label: 'Recovery Agent' },
  { value: 4, label: 'Investigator' },
  { value: 5, label: 'Camera Car' },
  { value: 6, label: 'Spotter' },
  { value: 7, label: 'Administrator' },
  { value: 8, label: 'Customer Rep' },
];

export const USER_ROLE_MAPPING = {
  'Branch Manager': 'branch_manager',
  'Recovery Agent': 'recovery_agent',
  Investigator: 'manager',
  'Camera Car': 'camera_car',
  Spotter: 'spotter',
  Administrator: 'administrator',
  'Customer Rep': 'admin',
};

/* Manage Shifts */
export const TIME_CLOCK_TYPES = {
  break: 'break',
  activity_tracker: 'activity_tracker',
  motion_tracker: 'motion_tracker',
};

export const BREAK_HOURS_OPTIONS = [
  { value: 0, label: 'Select Hours' },
  { value: 1, label: '1hr' },
  { value: 2, label: '2hrs' },
];

export const BREAK_MINS_OPTIONS = [
  { value: 0, label: 'Select Minutes' },
  { value: 5, label: '5 Mins' },
  { value: 10, label: '10 Mins' },
  { value: 15, label: '15 Mins' },
  { value: 20, label: '20 Mins' },
  { value: 25, label: '25 Mins' },
  { value: 30, label: '30 Mins' },
  { value: 35, label: '35 Mins' },
  { value: 40, label: '40 Mins' },
  { value: 45, label: '45 Mins' },
  { value: 50, label: '50 Mins' },
  { value: 55, label: '55 Mins' },
];

export const COMMISSION_TYPES = {
  individual: 'individual',
  team: 'team',
  per_vehicle: 'per_vehicle',
  custom: 'custom',
};

export const ACTIVITY_TRACKER_MIN_INTERVAL_MINUTES = 15;

export const MOTION_TRACKER_MIN_INTERVAL_MINUTES = 5;

/* Shift Dashboards & Stats */
export const ADMIN_DASHBOARD_CARDS = {
  active_shifts: 'Active Shifts',
  total_repossessions: 'Total Repossessions',
  total_spotted_vehicles: 'Total Spotted',
  total_lpr_scans: 'Total LPR Scans',
  units_pending_repossessions: 'Units Pending Repossessions',
  people_in_active_shifts: 'People In Active Shifts',
  commissions: 'Commissions',
  repossessions_hit_list: 'Repossession Hit List',
};

export const ADMIN_AS_GUEST_DASHBOARD_TABS = [
  { value: 1, label: 'Repossessions Overview' },
  { value: 2, label: 'People in this Shift' },
  { value: 3, label: 'Commissions' },
  { value: 4, label: 'Repossession Hit List' },
];

export const DRIVER_DASHBOARD_TABS = [
  { value: 1, label: 'Repossessions Overview' },
  { value: 2, label: 'People in this Shift' },
  { value: 3, label: 'Spotted Vehicle' },
  { value: 4, label: 'Shift Infractions' },
  { value: 5, label: 'Request Commission' },
];

export const SHIFT_STATS_CARDS = {
  drive_time_activity: 'Activity Level',
  infractions: 'Infractions',
  missed_opportunities: 'Missed Opportunities',
  missed_repossessions: 'Missed Repossessions',
  spotted_vehicles: 'Spotted Vehicles',
  repossessions: 'N of repossessions',
  total_hours_worked: 'Total Hours Worked',
  commission: 'Income',
};

export const COMMISSION_TYPES_SELECTION = [
  {
    icon: 'iconsminds-male',
    title: 'INDIVIDUAL',
    type: COMMISSION_TYPES.individual,
  },
  {
    icon: 'iconsminds-mens',
    title: 'TEAM',
    type: COMMISSION_TYPES.team,
  },
  {
    icon: 'iconsminds-car',
    title: 'PER VEHICLE',
    type: COMMISSION_TYPES.per_vehicle,
  },
];

export const COMMISSION_STATUSES = {
  approved: 'approved',
  pending: 'pending',
  declined: 'declined',
};

/* User Shift */
export const SHIFT_TYPES = {
  normal_shift: 'normal_shift',
  extraneous_time_tracked: 'extraneous_time_tracked',
};

export const SHIFT_STATUSES = {
  working: 'working',
  breaking: 'breaking',
  paused: 'paused',
  ended: 'ended',
};

export const BREAK_TIME_TYPES = {
  break: 'break',
  pause: 'pause',
  idle: 'idle',
  inactivity: 'inactivity',
};

// Employee can have only shifts which is -1 hr from now() or active shifts
export const SHIFT_AVAILABLE_LIMIT_TIME_HOURS = 1;

// If end shift early 20 mins or greater, then it's shift infraction
export const SHIFT_INFRACTION_END_EARLY_LIMIT_MINUTES = 20;

// Employee will be notified if he/she starts shift 10mins before the shift start time
export const SHIFT_STARTABLE_LIMIT_TIME_MINUTES = 10;

// If vehicle has been repossessed by another spotter, it can be reset to be spotted freshly after 10 hours
export const SPOTTED_VEHICLE_LIMITI_TIME_HOURS = 10;

export const SHIFT_FEED_CATEGORIES = {
  alert: 'alert',
  infraction: 'infraction',
  commission: 'commission',
  failed_checklist: 'failed_checklist',
  manual_hot_list: 'manual_hot_list',
};

export const SHIFT_FEED_TYPES = {
  shift_start_later: INFRACTION_TYPES.shift_start_later,
  shift_end_early: INFRACTION_TYPES.shift_end_early,
  shift_inactivity: INFRACTION_TYPES.shift_inactivity,
  shift_being_idle: INFRACTION_TYPES.shift_being_idle,
  shift_break_over_time: INFRACTION_TYPES.shift_break_over_time,
  shift_break_start: 'shift_break_start',
  shift_pause_start: 'shift_pause_start',
  shift_end_over_time: 'shift_end_over_time',
  shift_failed_checklist: 'shift_failed_checklist',
  shift_manual_hot_list: 'shift_manual_hot_list',
  custom_commission_request: 'custom_commission_request',
  shift_being_idle_offline: 'shift_being_idle_offline',
  shift_being_offline: 'shift_being_offline',
};

/* Task Management */
export const TO_DO_TABS = [
  { value: 1, label: 'Requested Commissions' },
  { value: 2, label: 'Commission History' },
];

/* Global settings */
export const GLOBAL_SETTINGS_TABS = [
  { value: 1, label: 'Branches' },
  { value: 2, label: 'Import Users' },
  { value: 3, label: 'Settings' },
];

/**
 * @deprecated use '@insightt/insightt-shared' task module.
 */
export const TASK_STATUSES = {
  open: 'open',
  closed: 'closed',
  new_deadline_approved: 'new_deadline_approved',
  new_deadline_cancelled: 'new_deadline_cancelled',
  new_deadline_declined: 'new_deadline_declined',
  completed: 'completed',
  new_deadline_proposed: 'new_deadline_proposed',
  marked_as_completed: 'marked_as_completed',
  uncompleted: 'uncompleted',
};

export const TASK_URGENCY_OPTIONS = [
  { value: 'high', label: 'High', color: 'danger' },
  { value: 'medium', label: 'Medium', color: 'pink' },
  { value: 'low', label: 'Low', color: 'info' },
];

/* Local events */
export const LOCAL_EVENTS = {
  new_commission: 'new_commission',
  refresh_shift_data: 'refresh_shift_data',
};

/* Notifications */

export const PAGE_SIZE = 10;

export const NOTIFICATION_CATEGORIES = {
  for_user: 'for_user',
  for_manager: 'for_manager',
};

export const NOTIFICATION_TYPES = {
  task_read: 'task_read',
  task_created: 'task_created',
  task_closed: 'task_closed',
  task_completed: 'task_completed',
  task_uncompleted: 'task_uncompleted',
  task_approved_new_deadline: 'task_approved_new_deadline',
  task_declined_new_deadline: 'task_decline_new_deadline',
  task_proposed_new_deadline: 'task_proposed_new_deadline',
  task_cancelled_new_deadline: 'task_cancelled_new_deadline',
  task_marked_as_completed: 'task_marked_as_completed',
  task_alloted_time_reminder: 'task_alloted_time_reminder',
  shift_start_later: INFRACTION_TYPES.shift_start_later,
  shift_end_early: INFRACTION_TYPES.shift_end_early,
  shift_inactivity: INFRACTION_TYPES.shift_inactivity,
  shift_being_idle: INFRACTION_TYPES.shift_being_idle,
  shift_break_over_time: INFRACTION_TYPES.shift_break_over_time,
  shift_break_start: 'shift_break_start',
  shift_pause_start: 'shift_pause_start',
  shift_end_over_time: 'shift_end_over_time',
  shift_failed_checklist: 'shift_failed_checklist',
  shift_manual_hot_list: 'shift_manual_hot_list',
  shift_nearby_spotted_vehicle: 'shift_nearby_spotted_vehicle',
  custom_commission_request: 'custom_commission_request',
  new_individual_commission: 'new_individual_commission',
  new_team_commission: 'new_team_commission',
  new_vehicle_commission: 'new_vehicle_commission',
  subscription_created: 'subscription_created',
  subscription_updated: 'subscription_updated',
  subscription_deleted: 'subscription_deleted',
  ping: 'ping',
};

export const NOTIFICATION_STATUSES = {
  created: 'created',
  read: 'read',
};

export const MY_STATS_LABELS = [
  {
    label: 'Drive Time Hours',
    key: '',
    value: '320',
    percent: '20.1',
    rank: 2,
    total: 10,
  },
  {
    label: 'Infractions',
    key: '',
    value: '320',
    percent: '20.1',
    rank: 2,
    total: 10,
  },
  {
    label: 'Missed Oppurtunities',
    key: '',
    value: '320',
    percent: '20.1',
    rank: 2,
    total: 10,
  },
  {
    label: 'Spotted Vehicles',
    key: '',
    value: '320',
    percent: '20.1',
    rank: 2,
    total: 10,
  },
  {
    label: 'Repossessions',
    key: '',
    value: '320',
    percent: '20.1',
    rank: 2,
    total: 10,
  },
  {
    label: 'Total Hours Worked',
    key: '',
    value: '320',
    percent: '20.1',
    rank: 2,
    total: 10,
  },
  {
    label: 'Commission Earned',
    key: '',
    value: '320',
    percent: '20.1',
    rank: 2,
    total: 10,
  },
  {
    label: 'Task Stats',
    key: '',
    value: '320',
    percent: '20.1',
    rank: 2,
    total: 10,
  },
];

export const REPORT_DAILY_MODAL = {
  newAssignments: 'newAssignments',
  accountNotChecked: 'accountNotChecked',
  totalRepossessions: 'totalRepossessions',
  recoveryRate: 'recoveryRate',
  /**
   * @deprecated
   */
  confirmedNotRepossessed: 'confirmedNotRepossessed',
  repossessionsHitList: 'repossessionsHitList',
  liveHits: 'liveHits',
  liveHitsNotSecured: 'liveHitsNotSecured',
  scans: 'scans',
  spotted: 'spotted',
  spottedNotSecured: 'spottedNotSecured',
  spottedVehicles: 'spottedVehicles',
  checkIns: 'checkIns',
};

export enum ModalType {
  SPOTTERS = 'spotters',
  RECOVERY = 'recovery',
  SCANS = 'scans',
  SCANS_PER_DAY = 'scans-per-day',
  LPR_TOTAL_HITS_AGENTS = 'lpr-total-hits-agents',
  LPR_TOTAL_HITS_CLIENTS = 'lpr-total-hits-clients',
  LPR_TOTAL_SCANS = 'lpr-total-scans',
  LPR_UNIQUE_SCANS = 'lpr-unique-scans',
  ACCOUNT_NOT_CHECKED = 'account-not-checked',
  SPOTTED_VEHICLE_SEARCH_VIN = 'search-vin-modal',
  NO_CASES = 'no-cases-modal',
  SELECT_CASE = 'select-case-modal',
  FORM_SPOTTED_VEHICLE = 'form-spotted-vehicle',
}

export enum DailyMapTabType {
  TOTAL_REPOSSESSIONS = 'totalRepossessions',
  SPOTTED = 'spotted',
  SPOTTED_NOT_SECURED = 'spottedNotSecured',
}

export enum ReportDailyMetric {
  ACCOUNT_NOT_CHECKED = 'accountNotChecked',
  CHECK_INS = 'checkIns',
  LIVE_HITS = 'liveHits',
  LIVE_HITS_NOT_SECURED = 'liveHitsNotSecured',
  NEW_ASSIGNMENTS = 'newAssignments',
  RECOVER_RATES = 'recoverRates',
  REPOSSESSIONS_HIT_LIST = 'repossessionsHitList',
  SCANS = 'scans',
  SPOTTED = 'spotted',
  SPOTTED_NOT_SECURED = 'spottedNotSecured',
  TOTAL_REPOSSESSIONS = 'totalRepossessions',
  DAILY_RECOVERY_RATE = 'dailyRecoveryRate',
  SPOTTED_VEHICLES = 'spottedVehicles',
  OVERSIGHTT_REPOSSESSION = 'oversighttRepossession',
}

export const REPORT_DAILY_COLUMN_NAME = {
  [REPORT_DAILY_MODAL.newAssignments]: 'ASSIGNMENT DATE',
  [REPORT_DAILY_MODAL.accountNotChecked]: 'ASSIGNMENT DATE',
  [REPORT_DAILY_MODAL.totalRepossessions]: 'REPOSSESSION DATE',
  [REPORT_DAILY_MODAL.repossessionsHitList]: 'SPOTTED DATE',
  [REPORT_DAILY_MODAL.liveHits]: 'LIVE HIT DATE',
  [REPORT_DAILY_MODAL.liveHitsNotSecured]: 'LIVE HIT DATE',
  [REPORT_DAILY_MODAL.spotted]: 'SPOTTED DATE',
  [REPORT_DAILY_MODAL.spottedNotSecured]: 'SPOTTED DATE',
  [REPORT_DAILY_MODAL.checkIns]: 'CHECK IN DATE',
};

export const FORMAT_DATE_TIME = 'YYYY-MM-DD hh:mm:ss';

export const TOP_RECOVERY_AGENTS_TOOLTIP = [
  'Filtered by repossessed branch.',
  'Users may show in other branches if they recovered a vehicle there.',
  "'Chase' cases not included due to API restrictions.",
];

export const TOP_SPOTTERS_TOOLTIP = [
  'Filtered by Spotted Branch.',
  'Users may show in other branches if they spotted a vehicle there.',
  "The numbers may not add up because some cases are still in 'Open/Need info' status.",
  "'Chase' cases not included due to API restrictions.",
];

export const TOP_CAMERA_CARS_TOOLTIP = [
  'Filtered by User Branch.',
  'Secured counts camera-assisted cases repossessed within 24 hours of scan.',
  "'Chase' cases not included due to API restrictions.",
];

export const UNASSIGNMENTS_TOOLTIP = [
  'Unassigned cases are those VINs shown in DRN as LPR or Direct Hits but are not listed in RDN.',
];

export const DateRangeSelector = {
  MTD: 'MTD',
  YTD: 'YTD',
  CUSTOM: 'CUSTOM',
} as const;

export const MONTH_PICKER_FORMAT = 'MMMM-YYYY';

export const MONTH_PICKER_FORMAT_LUXON = 'MMMM-yyyy';

export const ADMIN_USER_LIMIT_MESSAGE_MODAL =
  'You have reached the maximum number of users allowed by your current plan. To add a new user, please consider upgrading your plan to accommodate additional seats.';

export const NON_ADMIN_USER_LIMIT_MESSAGE_MODAL =
  'You have reached the maximum number of users allowed by your plan. To add a new user, please request that your admin upgrade your plan to accommodate additional seats.';

export const SEARCH_PARAM_KEYS = {
  rangeFilter: 'range-filter',
  unitReachStatus: 'reach-status',
  repoHitListActiveView: 'repo-hit-list-active-view',
  dailyModalType: 'daily-modal-type',
  dailyMapType: 'dailyMapType',
  branch: 'branch',
  viewType: 'view-type',
  dailySelector: 'daily-selector',
  period: 'period',
  year: 'year',
  month: 'month',
  clientName: 'clientName',
  agentName: 'agentName',
  agentId: 'agentId',
  clientId: 'clientId',
  lienholderId: 'lienholderId',
  lienholderName: 'lienholderName',
  'lienholder-id': 'lienholder-id',
  'lienholder-name': 'lienholder-name',
  userId: 'userId',
  agentToggle: 'agentToggle',
  drnId: 'drnId',
  liveHitType: 'liveHitType',
  // ! Should replace this param for "branch" everywhere.
  branchId: 'branchId',
  ytd: 'ytd',
  calendarDate: 'calendarDate',
  date: 'date',
  rankValue: 'rankValue', // ? rank option
  rankLabel: 'rankLabel',
  title: 'title',
  name: 'name',
  firstName: 'firstName',
  lastName: 'lastName',
  status: 'status',
  startDate: 'startDate',
  endDate: 'endDate',
  startDateTime: 'startDateTime',
  endDateTime: 'endDateTime',
  // * MODALS
  recoveryModal: 'recoveryModal',
  spottersModal: 'spottersModal',
  camerasModal: 'camerasModal',
  'repo-modal': 'repo-modal',
  'assignment-modal': 'assignment-modal',
  'missed-repo-modal': 'missed-repo-modal',
  // * TABS
  recoveryTab: 'recoveryTab',
  spottersTab: 'spottersTab',
  camerasTab: 'camerasTab',
  'total-hours': 'total-hours',
  'idle-hours': 'idle-hours',
  'drive-hours': 'drive-hours',
  orderType: 'orderType',
  hitsTab: 'hitsTab',
  hitsTypes: 'hitsTypes',
  timeSelector: 'timeSelector',
  clientPieChartTab: 'clientPieChartTab',
  clientListTab: 'clientListTab',
  viewTab: 'viewTab',
  dateTab: 'dateTab',
  basicDashboardTab: 'basicDashboardTab',
  basicDashboardListTab: 'basicDashboardListTab',
  basicDashboardSwitch: 'basicDashboardSwitch',
  peopleWorkingTab: 'peopleWorkingTab',
  peopleInShiftTab: 'peopleInShiftTab',
  dailyMapTab: 'dailyMapTab',
  'task-tab': 'task-tab',
  'task-status-tab': 'task-status-tab',
  'client-selector': 'client-selector',
  topCamerasTab: 'topCamerasTab',
  userRoleType: 'user-role-type',
  // * REDIRECTS
  from: 'from',
  paramsFrom: 'paramsFrom',
  // * STRIPE & SUBSCRIPTION
  checkoutSessionId: 'checkoutSessionId',
  urlSuccess: 'urlSuccess',
  stepSubscription: 'step',
  updateSubscription: 'updateSubscription',
  caseHistoryTab: 'caseHistoryTab',
  caseActivityTab: 'caseActivityTab',
  clients: 'clients',
  users: 'users',
  vinSearch: 'vin-search',
  hitStatus: 'hit-status',
  spottedCasesStatus: 'spottedCasesStatus',
  caseDateType: 'caseDateType',
  vin: 'vin',
  orderBy: 'orderBy',
  orderByKey: 'orderByKey',
  cameraHitsStatus: 'cameraHitsStatus',
  dateType: 'dateType',
  modalType: 'modalType',
  spottedVehiclesType: 'spottedVehiclesType',
} as const;

export const SEARCH_PARAMS_VALUES = {
  caseDateType: {
    recoveryDate: 'recoveryDate',
    spottedDate: 'spottedDate',
  },
  reachStatus: {
    accessible: CasesUnitReachStatus.ACCESSIBLE,
    obstructed: CasesUnitReachStatus.OBSTRUCTED,
    all: 'All',
  },
  viewType: {
    allTime: 'all-times',
    daily: 'daily',
    dailyMap: 'daily-map',
  },
  viewTab: {
    list: 'list',
    map: 'map',
  },
  dailySelector: {
    yesterday: 'yesterday',
    today: 'today',
  },
  true: 'true',
  false: 'false',
  recoveryTab: {
    totalRepossessions: 0,
    involuntary: 1,
    voluntary: 2,
  },
  spotterTab: {
    totalSpotted: 0,
    secured: 1,
    closed: 2,
  },
  camerasTab: {
    totalScans: 0,
    liveHits: 1,
    secured: 2,
  },
  overviewCamerasTab: {
    totalScans: 1,
    liveHits: 2,
    secured: 3,
  },
  orderType: {
    all: 'all',
    voluntary: 'voluntary',
    involuntary: 'involuntary',
    impound: 'impound',
  },
  hitsTab: {
    lprListAndDirectList: 'lprListAndDirectList',
    LprList: 'LprList',
    directList: 'directList',
  },
  hitsTypes: {
    all: 'all',
    lpr: HitType.LPR,
    direct: HitType.DIRECT,
  },
  hitStatus: {
    secured: CameraHitsStatus.SECURED,
    notSecured: CameraHitsStatus.NOTSECURED,
    all: 'All',
    open: CameraHitsStatus.OPEN,
    closed: CameraHitsStatus.CLOSED,
  },
  spottedCasesStatus: {
    open: CaseStatus.OPEN,
    closed: CaseStatus.CLOSED,
    secured: CaseStatus.REPOSSESSED,
    all: 'All',
  },
  dateTab: {
    daily: DateConstants.DAILY,
    weekly: DateConstants.WEEKLY,
    biWeekly: DateConstants.BI_WEEKLY,
    monthly: DateConstants.MONTHLY,
    ytd: DateConstants.YTD,
  },
  from: {
    overview: 'overview',
    viewAllTopRecovery: 'viewAllTopRecovery',
    viewAllTopSpotters: 'viewAllTopSpotters',
    viewAllTopCameraCars: 'viewAllTopCameraCars',
    viewAllTopRecoveryReports: 'viewAllTopRecoveryReports',
    viewAllTopSpottersReports: 'viewAllTopSpottersReports',
    viewAllTopCameraCarsReports: 'viewAllTopCameraCarsReports',
    reports: 'reports',
    clientDetailReport: 'clientDetailReport',
  },
  urlRedirect: {
    overview: '/app/overview',
    viewAllTopRecovery: '/app/overview/top-recovery-agent',
    viewAllTopSpotters: '/app/overview/top-spotters',
    viewAllTopCameraCars: '/app/overview/top-camera-cars',
    reports: '/app/reports/company',
    reportsAllTimes: '/app/reports/company/all-times',
    reportsDaily: '/app/reports/company/daily-map',
    reportsDailyMap: '/app/reports/company/daily',
    clientDetailReport: '/app/reports/clients',
    lenderDetailReport: '/app/reports/client/lender',
    lienholderDetailReport: '/app/reports/client/lienholder',
    lenderLienholderDetailReport: '/app/reports/client/lender-lienholder',
    viewAllTopRecoveryReports: '/app/reports/top-recovery-agent',
    viewAllTopSpottersReports: '/app/reports/top-spotters',
    viewAllTopCameraCarsReports: '/app/reports/top-camera-cars',
    activeShifts: '/app/active-shifts',
  },
  clientPieChartTab: {
    mtd: DateRangeSelector.MTD,
    ytd: DateRangeSelector.YTD,
    custom: DateRangeSelector.CUSTOM,
  },
  clientListTab: {
    mtd: DateRangeSelector.MTD,
    ytd: DateRangeSelector.YTD,
    custom: DateRangeSelector.CUSTOM,
  },
  timeSelector: {
    mtd: DateRangeSelector.MTD,
    ytd: DateRangeSelector.YTD,
  },
  dailyMapTab: {
    [DAILY_MAP_TOGGLE_OPTIONS.TOTAL_REPOSESSIONS_TAB]: DAILY_MAP_TOGGLE_OPTIONS.TOTAL_REPOSESSIONS_TAB,
    [DAILY_MAP_TOGGLE_OPTIONS.SPOTTED_TAB]: DAILY_MAP_TOGGLE_OPTIONS.SPOTTED_TAB,
    [DAILY_MAP_TOGGLE_OPTIONS.SPOTTED_NOT_SECURED_TAB]: DAILY_MAP_TOGGLE_OPTIONS.SPOTTED_NOT_SECURED_TAB,
  },
  taskTab: {
    all: 'all',
    me: 'me',
    others: 'others',
  },
  taskStatusTab: {
    all: 'all',
    'in-progress': 'in-progress',
    completed: 'completed',
    'pending-approval': 'pending-approval',
    incomplete: 'incomplete',
  },
  clientSelector: {
    lender: 'lender',
    lienholder: 'lienholder',
  },
  basicDashboardDateTab: {
    daily: DateConstants.DAILY,
    weekly: DateConstants.WEEKLY,
    monthly: DateConstants.MONTHLY,
  },
  basicDashboardListTab: {
    activityFeed: 'activity-feed',
    repoHitList: 'repo-hit-list',
    manualHotList: 'manual-hot-list',
  },
  peopleWorkingTab: {
    all: PEOPLE_WORKING_ALL_ROLES,
    recoveryAgents: UserType.RECOVERY_AGENT_TYPE,
    spotters: UserType.SPOTTER_TYPE,
    cameraCars: UserType.CAMERA_CAR_TYPE,
    others: PEOPLE_WORKING_OTHER_ROLES,
  },
  basicDashboardSwitch: {
    v1: 'v1',
    v2: 'v2',
  },
  caseHistoryTab: {
    missedRepo: 'missed-repo',
    timesSpotted: 'times-spotted',
    liveHits: 'live-hits',
  },
  caseActivityTab: {
    statusChanges: 'status-changes',
    checkIns: 'check-ins',
    rdnActivities: 'rdn-activities',
  },
  userTypes: {
    clients: 'client',
    agents: 'user',
  },
  spottedVehiclesType: {
    spot: 'spot',
    lprSpot: 'lpr-spot',
  },
};

export const APOLLO_ROOT_QUERY_FIELD_NAMES = {
  rDNCases: 'rDNCases',
  spottedNotes: 'spottedNotes',
  aggregateRDNCase: 'aggregateRDNCase',
  cameraHitsByLender: 'cameraHitsByLender',
  cameraHitsByUser: 'cameraHitsByUser',
  cameraHitsByLenderV2: 'cameraHitsByLenderV2',
  cameraHitsByUserV2: 'cameraHitsByUserV2',
  cameraHitDetailListV2: 'cameraHitDetailListV2',
  drnCameraScans: 'drnCameraScans',
  repoHitListSpottedDetails: 'repoHitListSpottedDetails',
  users: 'users',
  aggregateUser: 'aggregateUser',
} as const;

export const UNKNOWN_CLIENT = 'Unknown Client';
export const UNKNOWN_LIENHOLDER = 'Unknown Lienholder';

export const ZOOM_TO_MARKER = 14;

export const APP_COLORS = Object.freeze({
  themeColor1: '#006aff',
  themeColor2: '#13bf94',
  themeColorRed: '#eb4335',
  blue: '#006aff',
  green: '#13bf94',
});

export const LUXON_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  ...DateTime.DATE_FULL,
  month: 'short',
};

const SHIFT_NORMAL_DASHBOARD_BASE_URL = '/app/shift/dashboard';
const SHIFT_MANUAL_DASHBOARD_BASE_URL = '/app/shift/on-manual-time';
export const ROUTES = {
  overview: {
    base: '/app/overview',
    liveHits: '/app/overview/live-hits',
    liveHitsNewDatePicker: '/app/overview/new-live-hits',
    reopenedCases: '/app/overview/reopened-cases',
    reopenedRepoCases: '/app/overview/reopened-repo-cases',
    topCameraCarsViewAll: '/app/overview/top-camera-cars',
    recoveryClientDetails: '/app/overview/recovery-client-details',
    clientTotalAssignments: '/app/overview/total-assignments-client',
    clientTotalRepossession: '/app/overview/total-repossession-client',
    clientMissedRepossession: '/app/overview/client-missed-repossessions',
    topSpottersDetails: '/app/overview/top-spotters/details',
  },
  reports: {
    base: '/app/reports',
    liveHits: '/app/reports/live-hits',
    liveHitsNewDatePicker: '/app/reports/new-live-hits',
    liveHitsNotSecured: '/app/reports/live-hits-not-secured',
    liveHitsYtd: '/app/reports/live-hits-ytd',
    clientLender: '/app/reports/client/lender',
    clientLienholder: '/app/reports/client/lienholder',
    clientLenderLienholder: '/app/reports/client/lender-lienholder',
    clientTotalRepossession: '/app/reports/total-repossession-client',
    clientTotalAssignments: '/app/reports/total-assignments-client',
    clientMissedRepossessions: '/app/reports/client-missed-repossessions',
    daysStored: '/app/reports/days-stored',
    accountNotChecked: '/app/reports/account-not-checked',
    spotsPerRecovery: '/app/reports/spots-per-recovery',
    assignmentsChecked: '/app/reports/assignments-checked',
    lenderGroup: '/app/reports/client/groups/lender',
    lienholderGroup: '/app/reports/client/groups/lienholder',
    spottingAlerts: '/app/reports/spotting-alerts',
    topSpottersDetails: '/app/reports/top-spotters/details',
    newAssignments: '/app/reports/daily-view/newAssignments',
    totalRepossessions: '/app/reports/daily-view/total-repossessions',
    agentRepossessions: '/app/reports/agent-repossession',
    dailyReportCheckInsDetail: '/app/reports/daily-view-details/checkIns',
    repoHitList: '/app/reports/repo-hit-list',
    dailyReportTotalSpottedDetail: '/app/reports/daily-view-details/spotted',
    spottedNotSecured: '/app/reports/spotted-not-secured',
    dailyReportTotalSpottedDetailView: '/app/reports/daily-view/total-spots',
  },
  basicDashboardAdmin: {
    base: '/app/basic-dashboard-admin',
    liveHits: '/app/basic-dashboard-admin/live-hits',
    uniqueScans: '/app/basic-dashboard-admin/unique-lpr-scans',
    unitsPendingRepo: (queryString: string) => `/app/basic-dashboard-admin/units-pending-repo${queryString}`,
  },
  basicDashboard: {
    base: '/app/basic-dashboard',
    unitsPendingRepo: (queryString: string) => `/app/basic-dashboard/units-pending-repossession${queryString}`,
  },
  auth: {
    logout: '/user/logout',
    login: '/user/login',
  },
  myStats: {
    base: '/app/my-stats',
    spottedVehicles: '/app/my-stats/spotted-vehicles',
    repossessions: '/app/my-stats/repossessions',
    tasks: '/app/my-stats/tasks',
    infractions: '/app/my-stats/infractions',
    totalHits: '/app/my-stats/total-hits',
    totalUniqueScans: '/app/my-stats/total-unique-scans',
  },
  shifts: {
    manageShifts: '/app/settings/manage-shifts',
    createShift: '/app/create-shift/',
    editShift: (id: string) => '/app/edit-shift/' + id,
    normalShiftDashboard: SHIFT_NORMAL_DASHBOARD_BASE_URL,
    manualShiftDashboard: SHIFT_MANUAL_DASHBOARD_BASE_URL,
    normalDashboardRoutes: {
      assignToMe: `${SHIFT_NORMAL_DASHBOARD_BASE_URL}/assigned-to-me`,
      peopleInShift: `${SHIFT_NORMAL_DASHBOARD_BASE_URL}/people-in-shift`,
    },
    manualDashboardRoutes: {
      assignToMe: `${SHIFT_MANUAL_DASHBOARD_BASE_URL}/assigned-to-me`,
      peopleInShift: `${SHIFT_MANUAL_DASHBOARD_BASE_URL}/people-in-shift`,
    },
  },
  users: {
    base: '/app/human-resources/users',
    userDetails: (id: number) => '/app/human-resources/users/' + id,
  },
  checklist: {
    base: '/app/settings/manage-checklist',
    createMany: '/app/settings/checklist-create',
    checklistItem: '/app/settings/checklist-item',
  },
  cases: {
    base: '/app/cases',
    caseDetail: (id: string) => '/app/cases/' + id,
  },
  lpr: {
    base: '/app/lpr',
    totalHitsDetails: (queryString = '') => `/app/lpr/total-hits${queryString}`,

    securePercentage: (queryString: string) => `/app/lpr/secured-percentage${queryString}`,
    totalScansDetails: (queryString = '') => `/app/lpr/total-scans${queryString}`,
  },
  reviewHits: {
    base: '/app/review-hits',
    reviewHits: (queryString = '') => `/app/review-hits${queryString}`,
  },
  reviewHitsDashboard: {
    base: '/app/review-hits-dashboard',
    reviewHitsDashboard: (queryString = '') => `/app/review-hits-dashboard${queryString}`,
  },
  printable: {
    base: '/app/printable',
    lenderGroup: '/app/printable/client/groups/lender',
    lienholderGroup: '/app/printable/client/groups/lienholder',
    lender: '/app/printable/client/lender',
    lienholder: '/app/printable/client/lienholder',
    lenderLienholder: '/app/printable/client/lender-lienholder',
  },
  subscription: {
    base: '/app/subscription-management',
    updateSubscription: '/app/subscription-management?updateSubscription=true',
  },
  editCompany: '/edit-company',
  myProfile: '/app/my-profile',
} as const;

export const SPOTTERS_RANK_OPTIONS_FOR_FETCH_V2 = [
  { value: SpottersTabs.TOTAL, label: 'Total Spotted' },
  { value: SpottersTabs.REPOSSESSED, label: 'Secured' },
  { value: SpottersTabs.CLOSED, label: 'Closed' },
  { value: SpottersTabs.NEED_INFO, label: 'Need Info' },
];

export const SPOTTERS_RANK_OPTIONS_V2 = [
  {
    value: SpottersTabs.TOTAL,
    label: 'Total Spotted',
    trackingEvent: 'TS_CARD: CLICKED_TOTAL_SPOTTED',
    card: TOP_SPOTTERS_CARD_NAME,
  },
  {
    value: SpottersTabs.REPOSSESSED,
    label: 'Secured',
    trackingEvent: 'TS_CARD: CLICKED_SECURED',
    card: TOP_SPOTTERS_CARD_NAME,
  },
  {
    value: SpottersTabs.CLOSED,
    label: 'Closed',
    trackingEvent: 'TS_CARD: CLICKED_CLOSED',
    card: TOP_SPOTTERS_CARD_NAME,
  },
];

export const NOT_APPLICABLE = 'N/A';

export const MAX_SPOTTED_NOTE_LENGTH = 1000;
